export const gridLegend = [
  ['#171923', 'Impossible'],
  ['#2b2d3d', 'Unseen'],
  ['#535181', '1'],
  ['#7770af', '2–9'],
  ['#a399e8', '10–49'],
  ['#e6dcff', '50+'],
] as const;
